export function arrayDiff(oldArray: string[], newArray: string[]): [string[], string[]] {
    const oldSet = new Set(oldArray);
    const newSet = new Set(newArray);

    const oldMinusNew = [...oldSet].filter(x => !newSet.has(x));
    const newMinusOld = [...newSet].filter(x => !oldSet.has(x));
    return [oldMinusNew, newMinusOld];
}